import store from "@/store";
import { $loaderService } from "@/plugins/ELoaderService";

const redirecionarSeForProfAuxiliar = async (to, from, next) => {
  let currentUser = store.getters["Auth/user"];

  if (!currentUser) {
    await $loaderService.loadBasicDataIfNeeded();
  }

  currentUser = store.getters["Auth/user"];
  // eslint-disable-next-line
  if (!currentUser) {
    next({ name: "login" });
    return true; // Indica que houve redirecionamento
  }
  if (currentUser.roleName === "prof-auxiliar") {
    // Evita redirecionamento se já está na rota correta
    if (to.name === "gestoesDeAulas") {
      return false;
    }
    next({ name: "gestoesDeAulas" });
    return true; // Indica que houve redirecionamento
  }
  return false; // Não houve redirecionamento
};

export default redirecionarSeForProfAuxiliar;
